import Loader from './components/Loader';

interface ResultsLoaderProps {
  message?: string;
  heightClass?: string;
  loaderClassName?: string;
  containerClassName?: string;
}

export default function ResultsLoader({
  message = 'Preparing your PPT...',
  heightClass = 'h-[50vh]',
  loaderClassName = 'relative mb-4 h-20',
  containerClassName = '',
}: ResultsLoaderProps) {
  return (
    <div
      className={`flex ${heightClass} flex-col justify-center ${containerClassName}`}
    >
      <div className={loaderClassName}>
        <Loader />
      </div>
      <span className="text-center text-2xl font-semibold leading-normal text-gray-900">
        {message}
      </span>
    </div>
  );
}
